import { AppName, type PolicyViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the policy page.
 */
export const usePolicyPageModelData = (): PolicyViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Policy) {
    throw new Error("usePolicyPageModelData must be used on the policy page only");
  }
  return data;
};
